/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react';
import { Link, DatePicker, Label } from '@bingads-webui-react/fabric-control';
import { globalErrorMsg } from '@bingads-webui-campaign/hotel-common-upsert';
import { ErrorString } from './shared';
import { BidAdjustment } from './bid-adjustment';
import { getDatePickerStrings } from './utility';
import { CommonTextField } from './common-textfield';

function clearValidation({
  item, index, setIsDirty, isDirty,
}) {
  const isDirtyCopy = {};
  Object.entries(item).forEach(([key]) => {
    isDirtyCopy[`${key}-${index}`] = false;
  });
  setIsDirty({ ...isDirty, ...isDirtyCopy });
}
export function validateFn(validateParams) {
  if (validateParams.targetId) {
    if (document.getElementById(validateParams.targetId) && document.getElementById(validateParams.targetId).parentNode.querySelectorAll('.error-string').length) {
      validateParams.patchErrMsg(validateParams.targetName, globalErrorMsg);
    } else {
      validateParams.patchErrMsg(validateParams.targetName, '');
    }
  }
}
export function generateColumn(parmas) {
  const {
    item,
    index,
    column,
    i18n,
    serverContext,
    isDirty,
    setIsDirty,
    handleRemove,
    props: {
      handleChangeInput, handleBatchChangeInput, data, setData, getFieldErrorMsg, keySuffix, disableDecrease,
    },
  } = parmas;


  const fieldContent = item[column.fieldName];
  const fieldErrorMsg = getFieldErrorMsg(fieldContent);

  const formatDateValue = value => i18n.formatDate(value, { raw: serverContext.CurrentUser.CultureDateTimeFormat.ShortDatePattern });

  let { bidAdjustmentInput, bidAdjustmentDropdown } = item;
  if (!disableDecrease && bidAdjustmentInput - 0 < 0) {
    bidAdjustmentDropdown = 'Decrease by';
    bidAdjustmentInput = -bidAdjustmentInput;
  }
  switch (column.type) {
    case 'bid-adjustment':
      return (
        <Fragment>
          <BidAdjustment
            index={index}
            item={item}
            keySuffix={keySuffix}
            data={data}
            setData={setData}
            column={column}
            adjustmentDropdown={bidAdjustmentDropdown}
            adjustmentInput={bidAdjustmentInput}
            handleChangeInput={(key, value) => {
              handleChangeInput({ fieldName: key, index }, value);
            }}
            handleBatchChangeInput={(fieldName) => {
              handleBatchChangeInput({ fieldName, index });
            }}
            isDirty={isDirty}
            setIsDirty={setIsDirty}
            disableDecrease={disableDecrease}
          />
        </Fragment>);
    case 'input':
      return (
        <Fragment>
          <CommonTextField
            item={item}
            column={column}
            index={index}
            keySuffix={keySuffix}
            data={data}
            fieldContent={fieldContent}
            isDirty={isDirty}
            setIsDirty={setIsDirty}
            handleChangeInput={handleChangeInput}
            getFieldErrorMsg={getFieldErrorMsg}
          />
        </Fragment>);
    case 'remove':
      return (
        <Link
          className="target-remove-btn"
          disabled={data.useParentLevel}
          onClick={() => {
            handleRemove(index);
            clearValidation({
              data, item, index, setIsDirty, isDirty,
            });
          }}
        >
          {i18n.getString(_TL_('Remove'))}
        </Link>);
    case 'datePicker':
      return (
        <Fragment>
          <DatePicker
            strings={getDatePickerStrings(i18n)}
            ariaLabel={i18n.getString(_TL_('check-in date picker'))}
            isMonthPickerVisible
            showGoToToday={false}
            value={fieldContent}
            formatDate={value => formatDateValue(value)}
            onSelectDate={(value) => { setIsDirty({ ...isDirty, [`${column.fieldName}-${index}`]: true }); handleChangeInput({ fieldName: column.fieldName, index }, value); }}
            className={`date-picker ${!data.useParentLevel && (isDirty[`${column.fieldName}-${index}`]) && fieldErrorMsg ? 'input-error-border' : ''} `}
            disabled={data.useParentLevel}
          />
          {!data.useParentLevel && (isDirty[`${column.fieldName}-${index}`]) && fieldErrorMsg && <ErrorString error={fieldErrorMsg} />}
        </Fragment>
      );
    case 'plainString':
      return (<span className={column.spanClassName}>{fieldContent}</span>);
    default:
      return <Label style={{ fontWeight: 'normal' }}>{fieldContent && i18n.getString(fieldContent)}</Label>;
  }
}


export function getAllColumns({
  i18n,
  props,
  setIsDirty,
  handleRemoveAll,
  minBid,
  maxBid,
  extraBid,
  onlyExtra,
}) {
  const bidAdjustmentTitle = (
    <Fragment>
      <span>{i18n.getString(_TL_('Bid adjustment'))}</span>
    </Fragment>
  );
  const removetTitle = (
    <Link className="target-remove-all-btn" disabled={props.data.useParentLevel} onClick={() => { handleRemoveAll(); setIsDirty({}); }}>
      {i18n.getString(_TL_('Remove all'))}
    </Link>
  );

  let bidAdjustmentColumn = {
    key: 'bid-adjustment',
    name: bidAdjustmentTitle,
    fieldName: 'bidAdjustment',
    type: 'bid-adjustment',
    minWidth: 200,
    min: minBid,
    max: maxBid,
    extra: extraBid,
    onlyExtra,
  };

  const RemoveBtnColumn = {
    key: 'remove',
    name: removetTitle,
    fieldName: 'remove',
    type: 'remove',
    minWidth: 200,
  };

  let allColums = [...props.columns, bidAdjustmentColumn];
  if (props.showAddBtn) {
    bidAdjustmentColumn = {
      ...bidAdjustmentColumn,
      className: 'border-right',
      headerClassName: 'target-custom-header',
    };
    allColums = [...props.columns, bidAdjustmentColumn, RemoveBtnColumn];
  }
  if (props.noBidAdjustment) {
    allColums = [...props.columns];
  }
  return allColums;
}

